import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import AppShellNav from '../shell/AppShellNav';
import AppShellToolbar from '../shell/AppShellToolbar';
import ButtonCloudSync from './ButtonCloudSync';
import TransactionalAppBoundary from './TransactionalAppBoundary';
import { useNavigate } from 'react-router-dom';
import { getFreeAppTheme } from '../shell/getFreeAppTheme';
import '../shell/appShell.css';
import '../shell/freeAppContent.css';

/** Layout con manual de marca para apps gratuitas. */
export default function FreeAppLayout({
  title,
  description,
  keywords,
  backRoute = '/apps',
  children,
  showCloudSyncButton = true,
  mobileApp = false,
}) {
  const navigate = useNavigate();
  const theme = useMemo(() => getFreeAppTheme(), []);

  const handleSmartBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(backRoute, { replace: true });
    }
  };

  return (
    <div className={'app-shell free-app-shell' + (mobileApp ? ' mobile-finance-shell' : '')}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          {keywords ? <meta name="keywords" content={keywords} /> : null}
        </Helmet>

        <AppShellNav />

        <main className="app-shell-main">
          <div className="apps-wrap">
            <AppShellToolbar
              onBack={handleSmartBack}
              trailing={
                showCloudSyncButton ? (
                  <div className="app-shell-sync">
                    <ButtonCloudSync />
                  </div>
                ) : null
              }
            />
            <Box component="div" className="free-app-content">
              <TransactionalAppBoundary>{children}</TransactionalAppBoundary>
            </Box>
          </div>
        </main>
      </ThemeProvider>
    </div>
  );
}
